<template>
  <div>
    <h4 class="sub-heading">
      Tender Opportunities
    </h4>
    <div class="row" />
    <div class="tiles">
      <div class="row">
        <div class="col-md-3">
          <div class="tile red">
            <div>
              <label class="fs">Duration <i class="fa fa-filter" /></label>
            </div>
            <div class="mb-2">
              <v-select
                v-model="duration"
                :options="['Today','This Week','This Month']"
                @input="setDuration"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="tile red">
            <div class="tile-title">
              Tenders
            </div>
            <div class="tile-content mb-3">
              {{ $number.format(oppObj.tender_count) }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="tile blue">
            <div class="tile-title">
              Bidbonds
            </div>
            <div class="tile-content">
              {{ $number.format(oppObj.bid_count) }}
            </div>
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                :style="percent_opportunity"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ percent }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <bar-chart opportunity="opportunity.group_count" />
      </div>
      <div class="col-md-4">
        <pie-chart opportunity="opportunity" />
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment/src/moment';
import $ from 'jquery';
import BarChart from "./BarChart";
import PieChart from "./PieChart";

export default {
  components: {
    BarChart,
    PieChart
  },
  data() {
    return {
      dt: "",
      duration: 'Today',
      start: {
        date: moment().toDate()
      },
      to: {
        date: moment().toDate()
      }
    }
  },
  computed: {
    oppObj() {
      return this.$store.getters.getOpportunity;
    },
    percent() {
      return Math.ceil(this.oppObj.achieved / this.oppObj.opportunity * 100)+ "%";
    },
    percent_opportunity() {
      return "width:" + this.percent;
    },
    opportunity() {
      if (this.oppObj.length) {
        return this.oppObj.group_count
      }
      return [];
    },
    period() {
      return [this.start.date, this.to.date].join();
    }
  },
  watch: {
    period() {
      if (this.start.date && this.to.date) {
        this.fetch();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.dt = $(this.$refs.tb_rm_summary).DataTable({
        dom: 'Bfrtip',
        buttons: [{extend: 'csvHtml5', text: 'Excel'}]
      });
    });
    this.getOpportunity();
  },
  methods: {
    setDuration() {
      switch (this.duration) {
        case 'This Week':
          this.start.date = moment().startOf('week').toDate();
          this.to.date = moment().endOf('week').toDate();
          break;
        case 'This Month':
          this.start.date = moment().startOf('month').toDate();
          this.to.date = moment().endOf('month').toDate();
          break;
        default:
          this.start.date = moment().toDate();
          this.to.date = moment().toDate();
      }
    },
    getOpportunity() {
      if (!this.opportunity.length) {
        this.fetch();
      }
    },
    fetch() {
      this.$store.dispatch('fetchOpportunity', {start: this.start.date, end: this.to.date});
    },
  }
}
</script>
